import { render, staticRenderFns } from "./AggregateStatsCard.vue?vue&type=template&id=4ef4e2b3&"
import script from "./AggregateStatsCard.vue?vue&type=script&lang=js&"
export * from "./AggregateStatsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports